import FullscreenExitOutlinedIcon from "@mui/icons-material/FullscreenExitOutlined";
import FullscreenOutlinedIcon from "@mui/icons-material/FullscreenOutlined";
import {useTranslation} from "react-i18next";
import {RightSidebarActionButton} from "../../layout/rightSidebar/RightSidebarRail";

interface ReservationFullscreenButtonProps {
    isFullscreen: boolean;
    onChange: (isFullscreen: boolean) => void;
}

export function ReservationFullscreenButton({
    isFullscreen,
    onChange,
}: ReservationFullscreenButtonProps) {
    const {t} = useTranslation();
    const label = t(isFullscreen ? "Exit full screen" : "Enter full screen");

    return (
        <RightSidebarActionButton
            icon={isFullscreen
                ? <FullscreenExitOutlinedIcon/>
                : <FullscreenOutlinedIcon/>}
            label={label}
            active={isFullscreen}
            onClick={() => onChange(!isFullscreen)}
        />
    );
}
